import Api from './Api';
import Auth from '../Auth';
import Utils from '../Utils';
import Configs from '../Configs';

/**
 * @returns Api
 */
export const createInstance = authInstance => new Api(authInstance, Configs, Utils);

const instance = new Api(Auth, Configs, Utils);

export const request = ::instance.request;

export default instance;



// WEBPACK FOOTER //
// ./src/Api/index.js